module.exports = __webpack_public_path__ + "static/media/humza icons-10.2303f738.svg";